<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-50" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="sm:flex sm:items-start">
                                    <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:size-10">
                                        <ExclamationTriangleIcon class="size-6 text-yellow-600" aria-hidden="true" />
                                    </div>
                                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <DialogTitle as="h3" class="text-base font-semibold text-gray-900">{{ title }}</DialogTitle>
                                        <div class="mt-2">
                                            <p class="text-sm text-gray-500">{{ message }}</p>
                                            <ul class="mt-3 max-h-24 overflow-auto text-sm text-gray-700 bg-gray-100 rounded-md p-2 pl-5">
                                                <li v-for="(name, idx) in filesNames" class="flex items-center gap-1" :key="`duplicate-file-${idx}`">
                                                    <DocumentIcon class="size-3" />
                                                    <span>{{ name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button type="button" class="inline-flex w-full justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-500 sm:ml-3 sm:w-auto cursor-pointer" @click="uploadBoth">{{ uploadBothText }}</button>
                                <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto cursor-pointer" @click="skip">{{ skipText }}</button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { ExclamationTriangleIcon, DocumentIcon } from '@heroicons/vue/24/outline'

export default defineComponent({
    name: "DuplicateFilesModalComponent",

    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ExclamationTriangleIcon,
        DocumentIcon,
    },

    props: {
        open: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            default: 'Знайдено файли з однаковою назвою',
        },

        message: {
            type: String,
            default: 'Деякі обрані файли вже існують у галереї. Оберіть дію:',
        },

        filesNames: {
            type: Array as () => string[],
            default: () => [],
        },

        skipText: {
            type: String,
            default: 'Пропустити',
        },

        uploadBothText: {
            type: String,
            default: 'Завантажити обидва',
        }
    },

    methods: {
        close() {
            this.$emit('close');
        },
        skip() {
            this.$emit('skip');
        },
        uploadBoth() {
            this.$emit('upload-both');
        }
    }
});
</script>


